module.exports = __webpack_public_path__ + "img/30x30_yesil.b35d6ebb.gif";